/**
 * Pure helpers for the Manual Override section of the Recalculation Modal (PBI 10542).
 *
 * A manual override is a project, work order, agreement, or ACO the first run controls excluded and
 * that an approver deliberately opts back in to the calculation. Everything here is side-effect free so it can be
 * unit tested without jQuery, Kendo or the DOM. The DOM wiring lives in all.js.
 */

export const MANUAL_OVERRIDE_LABEL = 'Manual Override';

/**
 * Normalises the GetManualOverrideCandidates payload into the shape the widgets bind to.
 * The message is set when the approval period is not covered by any of the employee's plans.
 */
export function mapCandidatesResponse(response) {
    return {
        items: (response && response.Items) || [],
        message: (response && response.Message) || null,
    };
}

/**
 * True when this candidate has already been added in the current modal session.
 */
export function isAlreadyAdded(addedItems, candidate) {
    return (addedItems || []).some(
        added => added.ItemType === candidate.ItemType && added.Id === candidate.ItemId
    );
}

/**
 * Builds the grid row for an item added this session. It is always deletable: an item just added is
 * by definition added in the current period.
 */
export function toAddedRow(candidate) {
    return {
        Label: MANUAL_OVERRIDE_LABEL,
        ItemType: candidate.ItemType,
        Id: candidate.ItemId,
        Description: candidate.IdDescription,
        Deletable: true,
    };
}

/**
 * A manual override can only be removed in the same month it was added (PBI 10542 Change 3). The
 * modal already knows which period is being recalculated, so this compares that period against the
 * period the override was added in.
 */
export function isDeletableInCurrentPeriod(item, currentYear, currentMonth) {
    return item.AddedYear === currentYear && item.AddedMonth === currentMonth;
}

/**
 * Builds the grid row for an override that already existed before the modal was opened, fetched via
 * GetManualOverrideItems.
 */
export function toExistingRow(item, currentYear, currentMonth) {
    return {
        Label: MANUAL_OVERRIDE_LABEL,
        ItemType: item.ItemType,
        Id: item.ItemId,
        Description: item.IdDescription,
        Deletable: isDeletableInCurrentPeriod(item, currentYear, currentMonth),
    };
}
